'use client';

import { useActionState, useEffect } from 'react';

import { useToast } from '@/features/toast';
import { getLogger } from '@/shared/utils/logger/client';

const logger = getLogger();

import signOutAction from './action';

export function SignOut({ submit }: { submit: React.ReactNode }) {
	const { addToast } = useToast();
	const [state, formAction] = useActionState(signOutAction, {});

	useEffect(() => {
		(async () => {
			if (state.error) {
				logger.error('Ошибка при выходе из системы', state.error);
				addToast('Ошибка', state.error, 'error');
			}
		})();
	}, [addToast, state]);

	return <form action={formAction}>{submit}</form>;
}
